var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('section',[(!_vm.isLoading)?_c('crud-table',{attrs:{"headers":_vm.entityKeys,"data":_vm.entityData,"tableTitle":_vm.title,"store-module-name":_vm.storeModuleName,"updateHandler":_vm.updateHandler,"createHandler":_vm.createHandler,"deleteHandler":_vm.deleteHandler}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }